<template>
  <div class="fill-height">
    <v-progress-linear v-if="loading" color="primary" :height="5" indeterminate top absolute></v-progress-linear>

    <!-- <v-toolbar v-if="!loading && !noitems" class="border-top">
		<v-spacer></v-spacer>
		<v-btn depressed dark color="primary" :to="{name: 'my-adverts-edit'}">
			<v-icon left>mdi-plus</v-icon>
			<span>{{ trans('advert.post_advert') }}</span>
		</v-btn>
    </v-toolbar>-->

    <v-container fill-height style="max-width: 1366px">
      <v-layout align-start justify-center fill-height id="my-adverts" class="mb-8 pb-8 pt-2">
        <v-flex xs12>
          <div class="text-right">
            <v-btn
              dark
              rounded
              color="primary"
              class="mb-4 mr-4"
              :to="{name: 'my-adverts-edit'}"
            >Add Property</v-btn>
          </div>
          <server-side-iterator
            :pagination="pagination"
            :loading="loading"
            v-on:paginate="paginate"
            :grid="{xs12:true, sm12:true, lg4:true}"
          >
            <template v-slot:default="item">
              <advert-item
                class="my-2"
                v-bind="item"
                :deleting="instance_deleting"
                :publishing="instance_publishing"
                @publish="onPublish"
                @unpublish="onUnpublish"
                @edit="onEdit"
                @delete="onDelete"
              ></advert-item>
            </template>

            <template v-slot:no-data>
              <v-alert class="py-5 my-5" elevation="2">
                <p class="text-center">{{ trans('advert.no_adverts_message') }}</p>
                <!-- <div class="text-center">
                  <v-btn dark color="primary" :to="{name: 'my-adverts-edit'}">
                    <v-icon left>mdi-plus</v-icon>
                    <span>{{ trans('advert.post_advert') }}</span>
                  </v-btn>
                </div>-->
              </v-alert>
            </template>
          </server-side-iterator>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions } from "vuex";
import AdvertItemEditable from "../components/AdvertItemEditable";

export default {
  components: {
    "advert-item": AdvertItemEditable
  },

  data: () => ({}),

  computed: {
    ...mapState("adverts", {
      loading: "fetching",
      query: "query",
      pagination: "pagination",
      instance_deleting: "instance_deleting",
      instance_publishing: "instance_publishing"
    }),

    noitems: function() {
      return (
        this.loading == false && _.size(_.get(this.pagination, "data", [])) == 0
      );
    }
  },

  methods: {
    ...mapActions("adverts", {
      fetch: "fetch",
      publish: "publish",
      unpublish: "unpublish",
      deleteItem: "delete",
      setQueryParam: "setQueryParam"
    }),

    paginate: function(page) {
      this.$vuetify.goTo(0);
      this.setQueryParam({ page: page });
      this.fetch();
    },

    onEdit: function(uuid) {
      this.$router.push({
        name: "my-adverts-edit",
        params: { uuid: uuid }
      });
    },

    onPublish: function(uuid) {
      this.publish(uuid);
    },

    onUnpublish: function(uuid) {
      this.unpublish(uuid);
    },

    onDelete: function(uuid) {
      this.deleteItem(uuid);
    }
  },

  mounted: function() {
    this.fetch();
    this.$store.subscribe(({ type, payload }, state) => {});
  }
};
</script>